import styled from '@emotion/styled';

import { customPalette } from '../../../../styles/theme';

export const CardContainer = styled.div`
  background-color: ${customPalette.accent.white};
  border-radius: 16px;
  padding: 24px;
  box-shadow: none;
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  max-width: 340px;
  height: 400px;
`;

export const AvatarPlaceholder = styled.div`
  width: 120px;
  height: 120px;
  background-color: ${customPalette.grey[200]};
  border-radius: 50%;
  margin-bottom: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const AvatarIconWrapper = styled.div`
  svg {
    font-size: 80px;
    color: ${customPalette.grey[0]};
  }
`;

export const AvatarImage = styled.img`
  width: 120px;
  height: 120px;
  border-radius: 50%;
  object-fit: cover;
  margin-bottom: 24px;
`;

export const Name = styled.h2`
  font-size: 20px;
  font-weight: 600;
  color: ${customPalette.grey.dark};
  margin: 4px 0;
`;

export const Title = styled.p`
  font-size: 14px;
  font-weight: 500;
  color: ${customPalette.grey[400]};
  text-transform: uppercase;
  text-align: center;
  margin-bottom: 24px;
`;

export const InfoContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;
`;

export const EmailText = styled.span`
  display: block;
  white-space: normal;
  word-wrap: break-word;
  word-break: break-all;
  line-height: 1.5;
  text-align: center;
  max-width: 100%;
  overflow-wrap: break-word;
`;
